// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import OnLinkDialogContentBar from 'Ui/components/common/onlink-dialog/onlink-dialog-content-bar';
import OnlinkButton from 'Ui/components/common/onlink-button';
import {TextField} from '@deere/isg.component-library';
import {IconDelete, Copy} from '@deere/icons';

const ICON_DELETE_STYLE = {
    style: {
        display: 'inline',
        height: '20px',
        width: '20px'
    }
};

function EditorContentHeader(props) {
    const iconDelete = (
        <IconDelete
            {...ICON_DELETE_STYLE}
        />
    );

    const deleteButton = !props.isDefaultLayout && !props.isNew && (
        <OnlinkButton
            className='delete'
            onClick={props.onDelete}
            startIcon={iconDelete}
        >
            {props.translations.DELETE}
        </OnlinkButton>
    );

    const copyButton = !props.isNew && (
        <OnlinkButton
            className='copy'
            onClick={props.onCopy}
            startIcon={<Copy
                {...ICON_DELETE_STYLE}
            />}
        >
            {props.translations.CREATE_COPY}
        </OnlinkButton>
    );

    return (
        <OnLinkDialogContentBar className='editor-content-header'>
            <div className='input-container'>
                <TextField
                    disabled={props.isDefaultLayout}
                    name='dashboard-name'
                    onChange={props.onLayoutNameChange}
                    placeholder={props.translations.DASHBOARD_NAME}
                    slotProps={{
                        htmlInput: {
                            tabIndex: 0
                        }
                    }}
                    type='text'
                    value={props.name}
                />
                {copyButton}
            </div>
            {deleteButton}
        </OnLinkDialogContentBar>
    );
}

EditorContentHeader.propTypes = {
    isDefaultLayout: PropTypes.bool,
    isNew: PropTypes.bool,
    name: PropTypes.string,
    onCopy: PropTypes.func,
    onDelete: PropTypes.func,
    onLayoutNameChange: PropTypes.func,
    translations: PropTypes.translations
};

export default EditorContentHeader;
